import { Row, Dropdown, Button } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import classNames from 'classnames';
import { MoreOutlined } from '@ant-design/icons';
import { useDropdownMenu } from './useDropdownMenu';
import classes from './ProjectsConstructorCard.module.scss';

type PropsType = {
  isEdit: boolean;
  onClickMenuDelete: () => void;
  onClickMenuEdit: () => void;
  children: React.ReactNode;
  editForm: React.ReactNode;
  isCardUnremovable?: boolean;
  invalidCard?: boolean;
};

export const ProjectsConstructorCard = ({
  isEdit,
  onClickMenuDelete,
  onClickMenuEdit,
  editForm,
  children,
  isCardUnremovable,
  invalidCard,
}: PropsType) => {
  const menu = useDropdownMenu({ onClickMenuDelete, onClickMenuEdit, isCardUnremovable });

  return (
    <>
      {isEdit ? (
        <>{editForm}</>
      ) : (
        <div className={classNames(classes.cardWrapper, invalidCard && classes.invalidCard)}>
          {invalidCard && <ExclamationCircleFilled className={classes.errorIcon} />}
          <Row justify="space-between" align="top">
            {children}
          </Row>
          <Dropdown className={classes.dropdownToggler} overlay={menu} trigger={['click']}>
            <Button
              icon={<MoreOutlined className={classes.dropdownTogglerIcon} />}
              type="link"
              onClick={(e) => e.preventDefault()}
            ></Button>
          </Dropdown>
        </div>
      )}
    </>
  );
};
